import { useQueryClient } from '@tanstack/react-query';
import produce from 'immer';
import { useCallback } from 'react';

import { type ClipsListResponse } from '@air/api';
import { type Clip } from '@air/api/types';

import { getVersionsListKey } from '~/constants/react-query-keys';

export const useAddAssetVersion = () => {
  const queryClient = useQueryClient();

  const addAssetVersion = useCallback(
    (newVersion: Clip) => {
      queryClient.setQueryData<ClipsListResponse<Clip>>(getVersionsListKey({ assetId: newVersion.assetId }), (data) =>
        data
          ? produce(data, (draft) => {
              if (draft.data.clips.some((clip) => clip.id === newVersion.id)) {
                return;
              }

              // Set all existing versions to not be default
              draft.data.clips.forEach((clip) => {
                clip.isDefault = false;
              });

              // Add the new version as default at the front
              draft.data.clips.unshift({
                ...newVersion,
                isDefault: true,
                assetVersionCount: draft.data.clips.length + 1,
                version: draft.data.clips.length + 1,
              });
              draft.data.total++;
            })
          : {
              data: {
                clips: [
                  {
                    ...newVersion,
                    isDefault: true,
                    assetVersionCount: 1,
                    version: 1,
                  },
                ],
                total: 1,
              },
              pagination: {
                cursor: null,
                hasMore: false,
              },
            },
      );
    },
    [queryClient],
  );

  return {
    addAssetVersion,
  };
};
